// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import PolicyPage from './Policy';    // ← make sure this path is correct
import reportWebVitals from './reportWebVitals';
import TermPage from './Terms';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Main landing page */}
        <Route path="/" element={<App />} />

        {/* Privacy policy page */}
        <Route path="/privacy" element={<PolicyPage />} />
        <Route path="/terms" element={<TermPage />} />

        {/* You can add more here, e.g.:
            <Route path="/terms" element={<TermsPage />} />
        */}
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
